module.exports = __webpack_public_path__ + "img/7-4.84cdd236.png";